import { Route } from "react-router";

import Layout from "./components/layout";
import ProtectedRoute from "./components/protected-route";
import LoginView from "./components/login";
import DashboardView from "./components/dashboard";
import Logout from "./components/logout";
import DigitalTicketView from "./components/digital-ticket";
import TicketView from "./components/ticket";
import ContractorsView from "./components/contractors";
import ContractorCompanyView from "./components/contractors/company";
import ContractorContactView from "./components/contractors/contact";
import TransportsView from "./components/transports";
import TransportCompanyView from "./components/transports/company";
import TransportContactView from "./components/transports/contacts/contact";
import TruckView from "./components/transports/trucks/truck";
import UsersView from "./components/users";
import UserView from "./components/users/user";
import ReportsView from "./components/reports/reports-view";
import TicketLogView from "./components/ticket-log";
import {
  HaulageRecordView,
  SmallQuantityHaulageRecordView,
} from "./components/haulage-record";
import PrintRecordView from "./components/print-record/print-record-view";
import ScaleView from "./components/scale";
import { SettingsView } from "./components/settings";
import MaterialsView from "./components/materials";
import MaterialView from "./components/materials/material";
import MaterialTypeView from "./components/materials/material-type";
import ProjectView from "./components/contractors/project/contractor-project-view";
import ProjectLogView from "./components/project-log/project-log-view";
import SmallQuantityTicketRoute from "./components/small-quantity-ticket/small-quantity-ticket-route";
import HydrovacTicketRoute from "./components/hydrovac-ticket/hydrovac-ticket-route";
import SmallQuantityDigitalTicketView from "./components/small-quantity-ticket/small-quantity-digital-ticket-view";
import HydrovacDigitalTicketView from "./components/hydrovac-ticket/hydrovac-digital-ticket-view";
import RubbleTicketRoute from "./components/rubble-ticket/rubble-ticket-route";
import RubbleDigitalTicketView from "./components/rubble-ticket/rubble-digital-ticket-view";
import StorageAreasView from "./components/storage-areas";
import StockpileView from "./components/storage-areas/stockpile";
import StockpileSamplingView from "./components/storage-areas/stockpile/stockpile-sampling-view";
import ContainmentPadView from "./components/storage-areas/containment-pad";
import ContainmentPadSamplingView from "./components/storage-areas/containment-pad/containment-pad-sampling-view";

import "./styles/global.css";

export default () => (
  <Layout>
    <Route exact path="/" component={LoginView} />
    <Route exact path="/login" component={LoginView} />
    <Route path="/logout" component={Logout} />
    <Route path="/ticket/:id" component={TicketView} />
    <Route path="/haulage-record/:id" component={HaulageRecordView} />
    <Route
      path="/small-quantity-haulage-record/:id"
      component={SmallQuantityHaulageRecordView}
    />

    <ProtectedRoute path="/dashboard" component={DashboardView} />
    <ProtectedRoute path="/scale" component={ScaleView} />
    <ProtectedRoute path="/settings" component={SettingsView} />
    <ProtectedRoute path="/digital-ticket/:id" component={DigitalTicketView} />
    <ProtectedRoute path="/ticket-log/:id" component={TicketLogView} />
    <ProtectedRoute path="/small-quantity-ticket-log/:id" component={TicketLogView} />
    <ProtectedRoute path="/hydrovac-ticket-log/:id" component={TicketLogView} />
    <ProtectedRoute path="/project-log/:id" component={ProjectLogView} />
    <ProtectedRoute path="/print-record/:id" component={PrintRecordView} />
    <ProtectedRoute
      path="/contacts/:contactId/contractor-company/:companyId"
      component={ContractorContactView}
    />
    <ProtectedRoute
      path="/contractor-company/:id"
      component={ContractorCompanyView}
    />
    <ProtectedRoute path="/contractors" component={ContractorsView} />
    <ProtectedRoute
      path="/trucks/:truckId/transport-company/:companyId"
      component={TruckView}
    />
    <ProtectedRoute
      path="/contacts/:contactId/transport-company/:companyId"
      component={TransportContactView}
    />
    <ProtectedRoute
      path="/transport-company/:id"
      component={TransportCompanyView}
    />
    <ProtectedRoute path="/transports" component={TransportsView} />
    <ProtectedRoute path="/user/:id" component={UserView} />
    <ProtectedRoute path="/users" component={UsersView} />
    <ProtectedRoute path="/material/:id" component={MaterialView} />
    <ProtectedRoute path="/materials" component={MaterialsView} />
    <ProtectedRoute path="/material-type/:id" component={MaterialTypeView} />
    <ProtectedRoute path="/reports" component={ReportsView} />
    <ProtectedRoute
      path="/projects/:id/contractor-company/:companyId"
      component={ProjectView}
    />
    {/* Mirrors /ticket/:id - anonymous drivers get the dispatch form, staff the edit view. */}
    <Route path="/small-quantity/:id" component={SmallQuantityTicketRoute} />
    {/* Mirrors /digital-ticket/:id - printable, staff only. */}
    <ProtectedRoute
      path="/small-quantity-digital-ticket/:id"
      component={SmallQuantityDigitalTicketView}
    />
    <Route path="/hydrovac/:id" component={HydrovacTicketRoute} />
    <ProtectedRoute
      path="/hydrovac-digital-ticket/:id"
      component={HydrovacDigitalTicketView}
    />
    <Route path="/rubble/:id" component={RubbleTicketRoute} />
    <ProtectedRoute
      path="/rubble-digital-ticket/:id"
      component={RubbleDigitalTicketView}
    />
    <ProtectedRoute path="/rubble-ticket-log/:id" component={TicketLogView} />
    <ProtectedRoute
      path="/stockpile-sampling/:id"
      component={StockpileSamplingView}
    />
    <ProtectedRoute
      path="/containment-pad-sampling/:id"
      component={ContainmentPadSamplingView}
    />
    <ProtectedRoute path="/stockpile/:id" component={StockpileView} />
    <ProtectedRoute
      path="/containment-pad/:id"
      component={ContainmentPadView}
    />
    <ProtectedRoute path="/storage-areas" component={StorageAreasView} />
  </Layout>
);
